/**
 * Leene huisstijl (2026) — gebaseerd op de flyer "Het Omgevingscompas".
 * Donkergroen is de merkkleur (tekst, knoppen, lock); elke fase heeft een eigen
 * vlakkleur die overeenkomt met de stap in het compas.
 */
export const BRAND = {
  groen: '#1E3A2F',        // merkkleur: koppen, primaire knoppen, lock
  groenHover: '#2D5143',
  groenMuted: '#3F5A4E',
  papier: '#F4F6F1',       // zachte achtergrond (legenda-vlak flyer)
  tint: '#E8EEE6',
  rand: '#D9E2D5',
  randSterk: '#B9C8B4',
} as const;

export interface FaseKleur {
  /** Vlakkleur uit het compas */
  base: string;
  /** Lichte achtergrond voor panelen/actieve staat */
  soft: string;
  /** Rand/lijn die zichtbaar blijft op wit */
  border: string;
}

export const FASE_KLEUREN: Record<number, FaseKleur> = {
  1: { base: '#D2E6BD', soft: '#EEF5E6', border: '#C3DDA8' }, // Projectverkenning
  2: { base: '#E679A1', soft: '#FCE8EF', border: '#F0B5CB' }, // Omgevingsanalyse
  3: { base: '#87B7D7', soft: '#E8F1F8', border: '#BDD7E9' }, // Persona's
  4: { base: '#FDE5C6', soft: '#FEF4E7', border: '#F3D3A8' }, // Communicatiestrategie
  5: { base: '#68BFAE', soft: '#E1F2EE', border: '#ACDCCF' }, // Kernboodschap
  6: { base: '#FFFFFF', soft: BRAND.papier, border: BRAND.rand }, // Communicatiewerkplaats (neutraal)
};

export const faseKleur = (nr: number): FaseKleur => FASE_KLEUREN[nr] || FASE_KLEUREN[6];
